var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockedRoadPreparationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 86,
    viewBox: "0 0 103 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6315 3.57282C67.1849 1.33981 65.3985 0 63.1655 0H44.8548L45.748 13.3981H35.0295L35.9227 0H17.1654C14.9324 0 13.146 1.78641 12.6994 3.57282L0.641174 66.0971C0.194572 68.7767 2.42758 71.4563 5.10719 71.4563H31.4567L32.7965 49.1262H47.981L49.3208 71.4563H75.2237C77.9033 71.4563 80.1363 68.7767 79.6897 66.0971L67.6315 3.57282ZM33.2431 40.1942L34.1363 22.3301H45.748L46.6412 40.1942H33.2431Z",
    fill: "#C7D1DA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.0006 48.6654H86.6673V43.9987C86.6673 37.5587 81.4406 32.332 75.0006 32.332C68.5606 32.332 63.334 37.5587 63.334 43.9987V48.6654H61.0007C58.434 48.6654 56.334 50.7654 56.334 53.332V76.6654C56.334 79.232 58.434 81.332 61.0007 81.332H89.0006C91.5673 81.332 93.6673 79.232 93.6673 76.6654V53.332C93.6673 50.7654 91.5673 48.6654 89.0006 48.6654ZM75.0006 69.6654C72.434 69.6654 70.334 67.5654 70.334 64.9987C70.334 62.432 72.434 60.332 75.0006 60.332C77.5673 60.332 79.6673 62.432 79.6673 64.9987C79.6673 67.5654 77.5673 69.6654 75.0006 69.6654ZM82.234 48.6654H67.7673V43.9987C67.7673 40.0087 71.0106 36.7654 75.0006 36.7654C78.9906 36.7654 82.234 40.0087 82.234 43.9987V48.6654Z",
    fill: "#8A8F9D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 71.4563,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedRoadPreparationIcon);
export default __webpack_public_path__ + "static/media/LockedRoadPreparationIcon.b1f67b6b4f8c33c4633cda35644af918.svg";
export { ForwardRef as ReactComponent };